<template>
  <div>
    <L1 id="recordsarch">
      <template slot="slot_title">
        <RT :options="pages" :defaultValue="page" @input="page=$event"
        :inputStyle="{borderRadius: '3px 3px 0 0'}"
        :style="{position: 'absolute', bottom: 0, left: '490px'}" :bg="'#7FA7DA'" :height="'50px'"/>
      </template>
      <La1 :ratio="'490px 1fr'" :style="{gap: 0}">
        <template slot="left">
          <VIPCard :user="user" id="vip" :style="{marginTop: '27px'}" v-if="user"/>
          <searchVue :width="'405px'" :height="'50px'" :placeholder="'LINE名稱 / 暱稱 / 會員ID / 聯絡電話'" :defaultValue="searchText" @input="searchText=$event"
          id="searchinput" :style="{marginBlock: '0', marginTop: user ? '0' : '27px'}"/>
          <div class="user-ul" :style="{maxHeight: `calc(100vh - ${user ? '420px' : '182px'})`}">
            <div v-for="(uu, u) in users"  class="user-li" :key="`user-${u}`" @click="userid=uu._id">{{uu.lineName}}
              <div class="level"  v-if="uu.level" :style="{marignLeft: 'auto', backgroundImage: `url(${vipImg[uu.level]})`}">{{vipName[uu.level]}}</div>
            </div>
          </div>
        </template>
        <LaTable>
          <template slot="filter">
            <RT v-if="page==='入園紀錄'" :options="['全部', '發送', '核銷', '轉贈', '作廢']" :defaultValue="status" @input="status=$event"/>
            <RT v-else-if="page==='兌換使用紀錄'" :options="['全部', '發送', '兌換', '轉贈', '作廢']" :defaultValue="status" @input="status=$event"/>
            <RT v-else-if="page==='點數紀錄'" :options="['全部', '儲值', '使用']" :defaultValue="status" @input="status=$event"/>
            <RT v-else-if="page==='贈點紀錄'" :options="['全部', '贈送', '使用']" :defaultValue="status" @input="status=$event"/>
            <DateRange v-if="page!=='會員等級'" :defaultValue="range" @input="range=$event" :style="{width: '420px', marginLeft: 'auto', marginRight: '0'}"/>
          </template>
          <TableVue :rows="rows" v-if="page==='入園紀錄'">
            <template slot="slot_head">
              <th :style="{textAlign:'start', width: '260px'}">票券名稱</th>
              <th :style="{textAlign:'center'}">票券狀態</th>
              <th :style="{textAlign:'start', paddingLeft: '40px'}">票券編號</th>
              <template v-if="status==='全部'">
              <th :style="{textAlign:'start'}">入園地點時間</th>
              <th :style="{textAlign:'start'}">轉贈時間</th>
              </template>
              <template v-else-if="status==='核銷'">
              <th :style="{textAlign:'start'}">入園地點</th>
              <th :style="{textAlign:'start'}">入園時間</th>
                </template>
              <template v-else-if="status==='轉贈'">
              <th :style="{textAlign:'start'}">轉贈對象</th>
              <th :style="{textAlign:'start'}">轉贈時間</th>
                </template>
              <th :style="{textAlign:'start'}">發行時間</th>
            </template>
            <tr slot-scope="{item}" :style="{borderBottom:'none', height:'80px'}" :id="item._id">
              <td :style="{textAlign:'start'}">{{item.name}}</td>
              <td :style="{textAlign:'center'}">{{item.status}}</td>
              <td :style="{textAlign:'start', paddingLeft: '40px'}">{{item.ticketNumber||'電子票券'}}</td>

              <template v-if="status==='全部'">
              <td :style="{textAlign:'start'}">{{item.redemptionMachine || '-'}}<br>{{item.redemptionTime ? moment(item.redemptionTime).format('YYYY/MM/DD HH:mm') : '-'}}</td>
              <td :style="{textAlign:'start'}">{{item.transferTo?.userID?.lineName || '-'}}<br>{{item.transferTime ? moment(item.transferTime).format('YYYY/MM/DD HH:mm') : '-'}}</td>
              </template>
              <template v-else-if="status==='核銷'">
              <td :style="{textAlign:'start'}">{{item.redemptionMachine || '-'}}</td>
              <td :style="{textAlign:'start'}">{{item.redemptionTime ? moment(item.redemptionTime).format('YYYY/MM/DD HH:mm') : '-'}}</td>
              </template>
              <template v-else-if="status==='轉贈'">
              <td :style="{textAlign:'start'}">{{item.transferTo?.userID?.lineName || '-'}}</td>
              <td :style="{textAlign:'start'}">{{item.transferTime ? moment(item.transferTime).format('YYYY/MM/DD HH:mm') : '-'}}</td>
              </template>
              <td :style="{textAlign:'start'}">{{moment(item.createTime).format('YYYY/MM/DD HH:mm')}}</td>
            </tr>
          </TableVue>
          <TableVue :rows="rows" v-else-if="page==='兌換使用紀錄'">
            <template slot="slot_head">
              <th :style="{textAlign:'start', width: '340px'}">票券名稱</th>
              <th :style="{textAlign:'center'}">票券狀態</th>
              <th :style="{textAlign:'start', paddingLeft: '40px'}">票券編號</th>
              <template v-if="status==='全部'">
              <th :style="{textAlign:'start'}">使用地點時間</th>
              <th :style="{textAlign:'start'}">轉贈時間</th>
              </template>
              <template v-else-if="status==='兌換'">
              <th :style="{textAlign:'start'}">使用地點</th>
              <th :style="{textAlign:'start'}">使用時間</th>
                </template>
              <template v-else-if="status==='轉贈'">
              <th :style="{textAlign:'start'}">轉贈對象</th>
              <th :style="{textAlign:'start'}">轉贈時間</th>
                </template>
              <th :style="{textAlign:'start'}">發行時間</th>
            </template>
            <tr slot-scope="{item}" :style="{borderBottom:'none', height:'80px'}" :id="item._id">
              <td :style="{textAlign:'start'}">{{item.couponName}}</td>
              <td :style="{textAlign:'center'}">{{item.status}}</td>
              <td :style="{textAlign:'start', paddingLeft: '40px'}">{{item._id?.slice(14)||'電子票券'}}</td>

              <template v-if="status==='全部'">
              <td :style="{textAlign:'start'}">{{item.redemptionMachine || '-'}}<br>{{item.redemptionTime ? moment(item.redemptionTime).format('YYYY/MM/DD HH:mm') : '-'}}</td>
              <td :style="{textAlign:'start'}">{{item.transferTo?.userID?.lineName || '-'}}<br>{{item.transferTime ? moment(item.transferTime).format('YYYY/MM/DD HH:mm') : '-'}}</td>
              </template>
              <template v-else-if="status==='兌換'">
              <td :style="{textAlign:'start'}">{{item.redemptionMachine || '-'}}</td>
              <td :style="{textAlign:'start'}">{{item.redemptionTime ? moment(item.redemptionTime).format('YYYY/MM/DD HH:mm') : '-'}}</td>
              </template>
              <template v-else-if="status==='轉贈'">
              <td :style="{textAlign:'start'}">{{item.transferTo?.userID?.lineName || '-'}}</td>
              <td :style="{textAlign:'start'}">{{item.transferTime ? moment(item.transferTime).format('YYYY/MM/DD HH:mm') : '-'}}</td>
              </template>
              <td :style="{textAlign:'start'}">{{moment(item.createTime).format('YYYY/MM/DD HH:mm')}}</td>
            </tr>
          </TableVue>
          <TableVue :rows="rows" v-else-if="page==='點數紀錄'">
            <template slot="slot_head">
              <th :style="{textAlign: 'start', width: '260px'}">儲值時間</th>
              <th :style="{width: '150px'}">充值點數</th>
              <th :style="{width: '150px'}">總餘額</th>
              <th :style="{width: '240px', textAlign: 'start'}">操作內容</th>
              <th :style="{width: '190px', textAlign: 'start'}">操作人員</th>
            </template>
            <tr slot-scope="{item}" v-if="item.turnover">
              <td :style="{textAlign: 'start'}">{{moment(item.updateTime).format('YYYY/MM/DD HH:mm')}}</td>
              <td class="doll" :style="{color: item.turnover>0?'red':'var(--support1)'}">{{item.turnover>0?'+':''}}{{item.turnover}}</td>
              <td>{{item.balance}}</td>
              <td :style="{textAlign:'start'}" v-if="item.ticketId">點數換門票</td>
              <td :style="{textAlign:'start'}" v-else-if="item.couponId">點數換優惠券</td>
              <td :style="{textAlign:'start'}" v-else-if="item.orderId">
                {{moment(item.orderId.visitDate).format('gg-MM-DD')}}
                <br>{{item.action}} <span :style="{fontSize: '20px', color:'var(--color-highlight)'}"
                >${{(item.orderId.price)}}</span>

              </td>
              <td :style="{textAlign:'start'}" v-else-if="item.operator&&item.operator.role!=='user'&&item.operator.role!=='shop'">
                {{moment(item.updateTime).format('gg-MM-DD')}}<br>人工贈點</td>
              <td v-else></td>
              <td :style="{textAlign:'start'}">{{item.operator&&item.operator.role!=='user'&&item.operator.role!=='shop'?item.operator.name:'---'}}</td>
            </tr>
          </TableVue>
          <TableVue :rows="rows" v-else-if="page==='贈點紀錄'">
            <template slot="slot_head">
              <th :style="{textAlign: 'start', width: '260px'}">儲值時間</th>
              <th :style="{width: '150px'}">充值點數</th>
              <th :style="{width: '150px'}">總餘額</th>
              <th :style="{width: '240px', textAlign: 'start'}">操作內容</th>
              <th :style="{width: '190px', textAlign: 'start'}">操作人員</th>
            </template>
            <tr slot-scope="{item}" v-if="item.turnover">
              <td :style="{textAlign: 'start'}">{{moment(item.updateTime).format('YYYY/MM/DD HH:mm')}}</td>
              <td class="doll" :style="{color: item.turnover>0?'red':'var(--support1)'}">{{item.turnover>0?'+':''}}{{item.turnover}}</td>
              <td>{{item.points}}</td>
              <td :style="{textAlign:'start'}" v-if="item.ticketId">點數換門票</td>
              <td :style="{textAlign:'start'}" v-else-if="item.couponId">點數換優惠券</td>
              <td :style="{textAlign:'start'}" v-else-if="item.orderId">
                {{moment(item.orderId.visitDate).format('gg-MM-DD')}}
                <br>{{item.action}} <span :style="{fontSize: '20px', color:'var(--color-highlight)'}"
                >${{(item.orderId.price)}}</span>

              </td>
              <td :style="{textAlign:'start'}" v-else-if="item.operator&&item.operator.role!=='user'&&item.operator.role!=='shop'">
                {{moment(item.updateTime).format('gg-MM-DD')}}<br>人工贈點</td>
              <td v-else></td>
              <td :style="{textAlign:'start'}">{{item.operator&&item.operator.role!=='user'&&item.operator.role!=='shop'?item.operator.name:'---'}}</td>
            </tr>
          </TableVue>
          <TableVue :rows="rows" v-else>
            <template slot="slot_head">
              <th :style="{textAlign: 'start', width: '160px'}">會員等級</th>
              <th :style="{width: 'inherit', textAlign: 'start'}">等級期限</th>
              <th :style="{width: '150px', textAlign: 'start'}">修改日期</th>
              <th :style="{width: '240px', textAlign: 'start'}">來源</th>
              <th :style="{width: '8em', textAlign: 'start'}">操作人員</th>
            </template>
            <tr slot-scope="{item}">
              <td :style="{textAlign:'start'}">{{vipName[item.level]}}<span class="img" :style="{backgroundImage: `url(${vipImg[item.level]})`}"></span></td>
              <td :style="{textAlign:'start'}">{{moment(item.startTime).format('YYYY/MM/DD')}} ~ {{moment(item.expireTime).format('YYYY/MM/DD')}}</td>
              <td :style="{textAlign:'start'}">{{moment(item.updateTime).format('YYYY/MM/DD')}}</td>
              <td :style="{textAlign:'start'}">{{item.reason}}</td>
              <td :style="{textAlign:'start'}">{{item.operator&&item.operator.name || '---'}}</td>
            </tr>
          </TableVue>
        </LaTable>
      </La1>
    </L1>
  </div>
</template>

<script>
import DateRange from '../../components/input/dateRange.vue'
import TableVue from '../../components/tables/t2.vue'
import LaTable from '../../components/layout/LaTable.vue'
import VIPCard from './VIPCube.vue'
import RT from '../../components/radio/r1.vue'
import L1 from '../../components/layout/L1.vue'
import La1 from '../../components/layout/La1.vue'
import searchVue from '../../components/input/search.vue'
import { getapi } from '../../../tablet/store/fetch'
import { mapState } from 'vuex'
export default {
  components: { L1, La1, LaTable, RT, VIPCard, searchVue, TableVue, DateRange },
  data () {
    return {
      pages: ['兌換使用紀錄', '點數紀錄'],
      page: '兌換使用紀錄',
      status: '核銷',
      searchText: null,
      userid: null,
      user: null,
      users: [],
      rows: [],
      range: {
        start: this.moment().startOf('month').format('YYYY-MM-DD'),
        end: this.moment().endOf('month').format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapState({
      vipName: 'vipName',
      vipImg: 'vipImg'
    })
  },
  async mounted () {
    await this.getusers()
  },
  watch: {
    async searchText () {
      await this.getusers()
    },
    async userid () {
      if (this.userid) {
        this.user = await getapi(`users/vip/${this.userid}`)
      }
    },
    async user () {
      if (this.range.start && this.range.end && this.userid && this.user) {
        console.log('userChanged')
        await this.getdata()
      }
    },
    range: {
      deep: true,
      async handler () {
        if (this.range.start && this.range.end && this.userid && this.user) {
          console.log('rangeChanged')
          await this.getdata()
        }
      }
    },
    async page () {
      switch (this.page) {
        case '入園紀錄':
          if (this.status === '兌換' || this.status === '使用') this.status = '核銷'
          if (this.status === '儲值') this.status = '發送'
          break
        case '兌換使用紀錄':
          if (this.status === '核銷' || this.status === '使用') this.status = '兌換'
          if (this.status === '儲值') this.status = '發送'
          break
        case '點數紀錄':
          if (this.status === '兌換' || this.status === '核銷') this.status = '使用'
          if (this.status === '作廢' || this.status === '轉贈') this.status = '全部'
          if (this.status === '發送') this.status = '儲值'
          break
        case '贈點紀錄':
          if (this.status === '兌換' || this.status === '核銷') this.status = '使用'
          if (this.status === '作廢' || this.status === '轉贈') this.status = '全部'
          if (this.status === '發送') this.status = '贈送'
          break
      }
      if (this.range.start && this.range.end && this.userid && this.user) {
        console.log('pageChanged')
        await this.getdata()
      }
    },
    async status () {
      if (this.range.start && this.range.end && this.userid && this.user) {
        console.log('pageChanged')
        await this.getdata()
      }
    }
  },
  methods: {
    async getdata () {
      let routername
      let userid = this.user.memberID
      switch (this.page) {
        case '入園紀錄':
          routername = 'ticket/member'
          userid = this.userid
          break
        case '兌換使用紀錄':
          routername = 'coupons/member'
          break
        case '點數紀錄':
          routername = 'storedcardlogs'
          userid = this.userid
          break
        case '贈點紀錄':
          routername = 'storedcardlogs_free'
          userid = this.userid
          break
        case '會員等級':
          routername = 'users/level'
          userid = this.userid
          break
      }
      const params = { start: this.moment(this.range.start).startOf('day').toISOString(), end: this.moment(this.range.end).endOf('day').toISOString() }
      if (this.status !== '全部') {
        if (this.status === '贈送') {
          params.status = '儲值'
        } else {
          params.status = this.status
        }
      }
      console.log('getdata', `${routername}/${userid}?${new URLSearchParams(params)}`)
      this.rows = await getapi(`${routername}/${userid}?${new URLSearchParams(params)}`)
    },
    async getusers () {
      const params = {}
      if (this.searchText) {
        params.search = this.searchText
      }
      const data = await getapi('users/line2?' + new URLSearchParams(params))
      this.users = data
    }
  }

}
</script>
<style lang="scss">
#recordsarch {
  .L1_title {
    position: relative!important;
  }
  .La1_left {
    border-right: 1px solid #CACACA;
    padding: 0 30px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    overflow-y: auto;
    max-height: calc(100vh - 90px);
  }
  .filter {
    overflow: unset;
  }
}
</style>
<style lang="scss" scoped>
.img {
  display: inline-flex;
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.user-ul {
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
  padding: 5px 10px 27px;
}
.user-li {
  display: flex;
  width: 405px;
  height: 50px;
  min-height: 50px;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 25px;
  font-size: 20px;
  letter-spacing: .1em;
  color: #6D6D6D;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  &:last-child{
    margin-bottom: auto;
  }
}
.level {
  position: absolute;
  border-radius: 15px;
  background-color: #FFFFFF;
  top: 10px;
  right: 10px;
  height: 30px;
  width: 30px;
  color: var(--color-pri);
  display: flex;
  align-items: center;
  font-size: 16px;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
}
#vip {
  margin-bottom: 20px;
}
.searchinput {
  position: sticky;
  top: 0;
  margin-block: 0px 4px;
}
</style>
